import { useQuery } from '@tanstack/react-query';
import { authAPI } from '../api/endpoints';

/** Fallback while the settings are still loading, and for a user saved before the setting existed. */
export const FALLBACK_TODO_DAYS = 14;

/**
 * How many days after a send the follow-up todo falls due, from Profile -> Settings
 * (see docs/EMAIL_SEND.md).
 *
 * Reads the same `['current-user']` query the profile page writes after saving, so changing the
 * setting reaches every open composer without a refetch.
 */
export function useDefaultTodoDays(): number {
  const { data } = useQuery({
    queryKey: ['current-user'],
    queryFn: async () => {
      const response = await authAPI.me();
      return response.data;
    },
    staleTime: 5 * 60 * 1000,
  });

  return data?.settings?.default_todo_days ?? FALLBACK_TODO_DAYS;
}

/** Matches `MAX_TODO_DAYS` on the API, which rejects anything outside 1..365. */
export const MAX_TODO_DAYS = 365;
